import { ErrorHandler } from '@angular/core';
import * as i0 from "@angular/core";
var PreloadRoute = /** @class */ (function () {
    function PreloadRoute(errorHandler) {
        this.errorHandler = errorHandler;
        this.routes = {};
    }
    PreloadRoute.prototype.preload = function (preloadModule) {
        var load = this.routes[preloadModule];
        if (load) {
            load();
        }
        else {
            // don't throw because we don't want this to block.
            this.errorHandler.handleError(new Error("invalid preload module: " + preloadModule));
        }
    };
    /*
     * PRIVATE
     * This is only to be used by the OnDemandPreloadingStrategy helper service
     */
    PreloadRoute.prototype._registerRoute = function (route, load) {
        if (route.data && route.data.preloadModule) {
            this.routes[route.data.preloadModule] = load;
        }
    };
    PreloadRoute.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PreloadRoute_Factory() { return new PreloadRoute(i0.ɵɵinject(i0.ErrorHandler)); }, token: PreloadRoute, providedIn: "root" });
    return PreloadRoute;
}());
export { PreloadRoute };
